export const STRAVA_GET_AUTH_CODE_START = "STRAVA_GET_AUTH_CODE_START";
export const STRAVA_GET_AUTH_CODE_FINISH = "STRAVA_GET_AUTH_CODE_FINISH";
export const STRAVA_GET_AUTH_CODE_SUCCESS = "STRAVA_GET_AUTH_CODE_SUCCESS";
export const STRAVA_GET_AUTH_CODE = "STRAVA_GET_AUTH_CODE";

export const STRAVA_GET_ATHLETE_START = "STRAVA_GET_ATHLETE_START";
export const STRAVA_GET_ATHLETE_FINISH = "STRAVA_GET_ATHLETE_FINISH";
export const STRAVA_GET_ATHLETE_SUCCESS = "STRAVA_GET_ATHLETE_SUCCESS";
export const STRAVA_GET_ATHLETE = "STRAVA_GET_ATHLETE";

export const STRAVA_GET_ACTIVITIES_SUCCESS = "STRAVA_GET_ACTIVITIES_SUCCESS";
export const STRAVA_GET_ACTIVITIES_START = "STRAVA_GET_ACTIVITIES_START";
export const STRAVA_GET_ACTIVITIES_FINISH = "STRAVA_GET_ACTIVITIES_FINISH";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_FAIL_CLEAR = "AUTH_FAIL_CLEAR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_PASSWORD_RESET = "AUTH_PASSWORD_RESET";
export const AUTH_PASSWORD_RESET_FAIL = "AUTH_PASSWORD_RESET_FAIL";


export const SET_USER = "SET_USER";

export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";

export const GET_EVENTS_START = "GET_EVENTS_START";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FINISH = "GET_EVENTS_FINISH";
export const GET_EVENTS_FAIL = "GET_EVENTS_FAIL";
export const GET_EVENTS = "GET_EVENTS";
export const SELECT_EVENT = "SELECT_EVENT";
export const EVENT_ENTERED = "EVENT_ENTERED";
export const EVENT_ENTERED_CLEARED = "EVENT_ENTERED_CLEARED";

export const CAPTURE_START = "CAPTURE_START";
export const CAPTURE_SUCCESS = "CAPTURE_SUCCESS";
export const CAPTURE_FINISH = "CAPTURE_FINISH";
export const CAPTURE_FAIL = "CAPTURE_FAIL";

export const GET_ACTIVITIES_START = "GET_ACTIVITIES_START";
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";
export const GET_ACTIVITIES_FINISH = "GET_ACTIVITIES_FINISH";
export const GET_ACTIVITIES_FAIL = "GET_ACTIVITIES_FAIL";
